/**
 * This plugin keeps track of when a page is actually loaded. In other words, it
 * doesn't rely on the route path directly, but whether on if Nuxt deems the page
 * to have fetched all the data and is rendered.
 *
 * We need to use this in order to display certain components based on the
 * current page, but prevent them from disappearing while navigating.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const renderedRoute = useRenderedRoute()
  const renderedVisibility = useRenderedHeaderSearchFormVisibility()
  const stickyHeaderSearchFormShown = useStickyHeaderSearchFormShown()
  const route = useRoute()

  function syncRenderedRouteState() {
    renderedRoute.value = route?.name?.toString() ?? ''
    renderedVisibility.value = route?.meta?.headerSearchFormVisibility ?? 'visible'

    if (renderedVisibility.value === 'dynamic') {
      stickyHeaderSearchFormShown.value = false
    }
    else if (renderedVisibility.value === 'visible') {
      stickyHeaderSearchFormShown.value = true
    }
  }

  syncRenderedRouteState()

  nuxtApp.hook('page:loading:end', syncRenderedRouteState)
})
